module.exports = __webpack_public_path__ + "static/img/bg59.a460baf3.png";